import { create } from 'zustand';

/**
 * What the composer shows around a dictation session. assistant-ui's own dictation state only knows "starting",
 * "running" and "ended", so it can't tell recording from waiting on the transcript.
 */
export type DictationPhase = { type: 'idle' } | { startedAt: number; type: 'recording' } | { type: 'transcribing' };

type Store = {
	error: string | null;
	/** Kept after a failed transcription so the user can retry without speaking again. */
	failedRecording: Blob | null;
	phase: DictationPhase;
	clearError: () => void;
	fail: (error: string, failedRecording?: Blob) => void;
	setPhase: (phase: DictationPhase) => void;
};

export const useDictationStore = create<Store>()((set) => ({
	clearError: () => set({ error: null, failedRecording: null }),
	error: null,
	fail: (error, failedRecording) => set({ error, failedRecording: failedRecording ?? null, phase: { type: 'idle' } }),
	failedRecording: null,
	phase: { type: 'idle' },
	setPhase: (phase) => set(phase.type === 'idle' ? { phase } : { error: null, failedRecording: null, phase }),
}));
